/* import __COLOCATED_TEMPLATE__ from './seller-profile-sidebar.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

export default class SellerProfileSidebar extends Component {
  @service router;
  @service media;

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__sidebar';
  }

  get isInNetwork() {
    return this.args.currentCompanyConnection?.invited ?? false;
  }

  @action
  onBackClicked(e) {
    e.preventDefault();

    if (this.isInNetwork) {
      this.router.transitionTo(EMBER_ROUTE_NAMES.PEOPLE_CENTER__MY_NETWORK);
    } else {
      window.history.back();
    }
  }
}
